import React, { useEffect, useState } from "react";

const Mon = () => {
  const [mainData, setMainData] = useState([]);
  const [topBox, setTopBox] = useState([[], [], []]);
  const [bottomBox, setBottomBox] = useState([[], [], []]);
  const [serverTime, setServerTime] = useState("");

  const serverUrl =
    window.location.hostname === "localhost" ||
    window.location.hostname === "192.168.0.254"
      ? `http://${window.location.hostname}:4000`
      : `${window.location.protocol}//smes.izenimplant.com`;

  const fetchData = async () => {
    const res = await fetch(`${serverUrl}/api/monitoring`);
    const json = await res.json();

    const main = json[0] || [];
    const sub = json[1] || [];

    setMainData(main);
    if (main.length > 0) setServerTime(main[0].DT);

    const top = [[], [], []];
    const bottom = [[], [], []];

    sub.forEach(r => {
      if (!r.GU) return;

      const [mc, pos] = r.GU.split("-");
      const col = Number(mc) - 1;
      const p = Number(pos);

      if (col < 0 || col > 2) return;

      if (p <= 3) top[col].push(r);
      else bottom[col].push(r);
    });

    setTopBox(top);
    setBottomBox(bottom);
  };

  useEffect(() => {
    fetchData();
    const t = setInterval(fetchData, 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={styles.page}>

      <div style={styles.header}>
        <div style={styles.title}>MACHINE MONITORING</div>
        <div style={styles.clock}>{format(serverTime)}</div>
      </div>

      <div style={styles.row} className="mobileFix">

        {/* 상단 */}
        <StackBox list={topBox[0]} pos="top" />
        <StackBox list={topBox[1]} pos="top" />
        <StackBox list={topBox[2]} pos="top" />

        {/* NC */}
        {mainData.map(m => <Card key={m.MAC_NUM} m={m} />)}

        {/* 하단 */}
        <StackBox list={bottomBox[0]} pos="bottom" />
        <StackBox list={bottomBox[1]} pos="bottom" />
        <StackBox list={bottomBox[2]} pos="bottom" />

      </div>
    </div>
  );
};

//////////////////////////////
// StackBox
//////////////////////////////
function StackBox({ list, pos }) {
  const rows = list.slice(0, 3);

  let borderColor = "#ff2d2d";     // 기본 빨강

  if (pos === "top") borderColor = "#7c4dff";     // 좌상 색
  if (pos === "bottom") borderColor = "#40c4ff";  // 좌하 색

  return (
    <div style={{ ...styles.stack, border: `2px solid ${borderColor}` }}>
      {rows.map((d, i) => (
        <div style={styles.stackRow} className="stackRow">
          <span style={styles.cell}>{d.PPI_PROJECTNO}</span>
          <span style={styles.cell}>
            {d.PPI_DENTALNUM ? d.PPI_DENTALNUM : "-"}
          </span>
          <span style={styles.cell}>{d.BCU_NAME}</span>
          <span style={{...styles.cell, ...styles.patient}}>{d.PPI_PATIENTNAME}</span>
        </div>
      ))}
    </div>
  );
}


//////////////////////////////
// Card
//////////////////////////////
function Card({ m }) {
  const color = getColor(m.STATE);

  return (
    <div style={{ ...styles.card, borderColor: color }}>
      <div style={{ ...styles.state, background: color }}>{m.STATE}</div>

      <div style={styles.mc}>NC{m.MAC_NUM}</div>

      <Row label="설비" value={m.BMA_NAME} />
      <Row label="O NUMBER" value={m.PROGRAM_NUMBER} />
      <Row label="TOOL NUMBER" value={m.TOOL_NUMBER} />

      <Row
        label="치식 / 거래처 / 환자"
        value={`${m.PPI_DENTALNUM || "-"} / ${m.BCU_NAME || "-"} / ${m.PPI_PATIENTNAME || "-"}`}
      />

      <Row label="COUNT" value={Number(m.PART_COUNT).toLocaleString()} />
      <Row label="TIME" value={format(m.G_DATETIME)} />
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={styles.row2}>
      <div style={styles.label}>{label}</div>
      <div style={styles.value}>{value}</div>
    </div>
  );
}

function format(t) {
  if (!t) return "";
  return t.replace("T", " ").replace("Z", "").split(".")[0];
}

function getColor(state) {
  switch (state) {
    case "EMERGENCY": return "#ff1744";
    case "ALARM": return "#ff5252";
    case "EDIT": return "#ffd600";
    case "RUNNING": return "#00e676";
    case "IDLE": return "#40c4ff";
    case "SETUP": return "#ff9100";
    case "POWER_ON": return "#9e9e9e";
    default: return "#555";
  }
}

const styles = {
  page: {
    background: "#0b0f14",
    minHeight: "100vh",
    padding: 20,
    fontFamily: "Pretendard",
    color: "#fff"
  },

  header: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    marginBottom: 30
  },

  title: {
    gridColumn: "1/3",
    textAlign: "center",
    fontSize: 26,
    fontWeight: 800
  },

  clock: {
    justifySelf: "end",
    fontSize: 18,
    fontWeight: 600
  },

  ////////////////////////
  // 3열 고정
  ////////////////////////
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 20,
    marginBottom: 20
  },

  ////////////////////////
  // StackBox
  ////////////////////////
  stack: {
    minHeight: 150,
    borderRadius: 12,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: 14,
    overflow: "hidden"
  },

  ////////////////////////
  // 웹: 4칸
  ////////////////////////
  stackRow: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    alignItems: "center",
    gap: 12,
    fontSize: 18,
    borderBottom: "1px solid #333",
    paddingBottom: 6
  },

  ////////////////////////
  // 텍스트 줄바꿈 방지
  ////////////////////////
  cell: {
    minWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },

  patient: {
    color: "#8be9fd",
    textAlign: "right"
  },

  ////////////////////////
  // CARD
  ////////////////////////
  card: {
    position: "relative",
    background: "#121821",
    borderRadius: 16,
    padding: 24,
    border: "4px solid"
  },

  state: {
    position: "absolute",
    top: 15,
    right: 15,
    padding: "6px 14px",
    borderRadius: 8,
    fontWeight: 700,
    fontSize: 12
  },

  mc: {
    fontSize: 26,
    fontWeight: 800,
    marginBottom: 20
  },

  row2: { marginTop: 12 },

  label: {
    fontSize: 12,
    color: "#9aa3ad"
  },

  value: {
    fontSize: 18,
    fontWeight: 700
  }
};


export default Mon;

const style = document.createElement("style");
style.innerHTML = `

@media (max-width:768px){

  .mobileFix{
    display:flex !important;
    flex-direction:column !important;
    gap:20px !important;
  }

  .mobileFix > div{
    width:100% !important;
  }

  /* ===== StackRow 모바일 2x2 ===== */
  .stackRow{
    display:grid !important;
    grid-template-columns:1fr 1fr !important;
    row-gap:6px;
  }

  .stackRow span:nth-child(1){
    grid-column:1;
    grid-row:1;
  }
  .stackRow span:nth-child(2){
    grid-column:2;
    grid-row:1;
    text-align:right;
  }
  .stackRow span:nth-child(3){
    grid-column:1;
    grid-row:2;
  }
  .stackRow span:nth-child(4){
    grid-column:2;
    grid-row:2;
    text-align:right;
  }

  /* 순서 */
  .mobileFix > div:nth-child(1){order:1}
  .mobileFix > div:nth-child(4){order:2}
  .mobileFix > div:nth-child(7){order:3}

  .mobileFix > div:nth-child(2){order:4}
  .mobileFix > div:nth-child(5){order:5}
  .mobileFix > div:nth-child(8){order:6}

  .mobileFix > div:nth-child(3){order:7}
  .mobileFix > div:nth-child(6){order:8}
  .mobileFix > div:nth-child(9){order:9}
}

`;
document.head.appendChild(style);
